// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postReportSchedule } from 'services/TransactionExportService'
import { logSentryError } from 'utils/sentry'

export const usePostReportScheduleMutation = () => {
  return useMutation({
    mutationFn: postReportSchedule,
    onError: error => logSentryError('Error: usePostReportScheduleMutation', error),
  })
}
